module.exports = __webpack_public_path__ + "img/nothing.6f48f175.png";